import React, { useState } from 'react';
import GnulChapter6 from '../components/GnulChapter6';
import GnulSidebar from '../components/GnulSidebar';
import '../components/GnulLayout.css';

function GnulChapter6Page() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="gnul-layout">
      <button
        className="gnul-mobile-toggle"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open chapter menu"
      >
        <span className="gnul-toggle-icon">&#9776;</span>
        <span className="gnul-toggle-label">Chapters</span>
      </button>

      <GnulSidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="gnul-content">
        <GnulChapter6 />
      </div>
    </div>
  );
}

export default GnulChapter6Page;
